export default __webpack_public_path__ + "static/44-16783dcc919a60fb1c2f6763bf9dbeae.png";